import styled from 'styled-components';
import { colors } from '../styles/colors';

export default styled.div`
  color: ${colors.textSecondary};
  margin-top: 0.3rem;
  margin-bottom: 1rem;
`;
